import * as tslib_1 from "tslib";
import { ENTER } from '@angular/cdk/keycodes';
import { ChangeDetectorRef, ElementRef, EventEmitter, OnDestroy, OnInit, Renderer2, } from '@angular/core';
import { ControlValueAccessor, } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter } from '@angular/material/core';
import { MatCalendar, MatCalendarHeader, } from '@angular/material/datepicker';
import { AppStateFacade } from '@app-state';
import { isInternetExplorer } from '@uipath/angular/utilities';
import { unsubscribe } from '@utils/object.utils';
import groupBy from 'lodash-es/groupBy';
import isEqual from 'lodash-es/isEqual';
import * as moment from 'moment';
import { Subject, } from 'rxjs';
import { delay, filter, pairwise, startWith, } from 'rxjs/operators';
var CalendarView = {
    Month: 'month',
    Year: 'year',
    MultiYear: 'multi-year',
};
export var YEARS_PER_PAGE = 24;
var emptyRedraw = {};
/**
 * Overrides:
 * 'nextEnabled', 'previousEnabled'
 * and the Calendar's 'focusActiveCell'
 * This allows navigation through disabled calendar views
 */
var OutOfBoundsNavigationHeader = /** @class */ (function (_super) {
    tslib_1.__extends(OutOfBoundsNavigationHeader, _super);
    function OutOfBoundsNavigationHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OutOfBoundsNavigationHeader.prototype.ngOnInit = function () {
        this.calendar.focusActiveCell = function () { };
    };
    // Override default header state flags
    OutOfBoundsNavigationHeader.prototype.previousEnabled = function () { return true; };
    OutOfBoundsNavigationHeader.prototype.nextEnabled = function () { return true; };
    return OutOfBoundsNavigationHeader;
}(MatCalendarHeader));
export { OutOfBoundsNavigationHeader };
/**
 * Overrides:
 * 'clampDate'
 * This allows navigation through disabled calendar views
 */
var OutOfBoundsDateAdapter = /** @class */ (function (_super) {
    tslib_1.__extends(OutOfBoundsDateAdapter, _super);
    function OutOfBoundsDateAdapter(appState) {
        var _this = _super.call(this, moment.locale()) || this;
        _this._languageChangeSub = appState.language.change$
            .subscribe(function () { return _this.setLocale(moment.locale()); });
        return _this;
    }
    OutOfBoundsDateAdapter.prototype.clampDate = function (date) {
        return date;
    };
    OutOfBoundsDateAdapter.prototype.destroy = function () {
        unsubscribe(this._languageChangeSub);
    };
    return OutOfBoundsDateAdapter;
}(MomentDateAdapter));
export { OutOfBoundsDateAdapter };
var DATES = {
    yesterday: moment().add(-1, 'days'),
    tomorrow: moment().add(1, 'days'),
    today: moment(),
};
var UiCalendarComponent = /** @class */ (function () {
    function UiCalendarComponent(_renderer, _dateAdapter, _cd, _element) {
        this._renderer = _renderer;
        this._dateAdapter = _dateAdapter;
        this._cd = _cd;
        this.startAt = null;
        this.startView = CalendarView.Month;
        this.selected = null;
        this.headerComponent = OutOfBoundsNavigationHeader;
        this.selectedChange = new EventEmitter();
        this.yearSelected = new EventEmitter();
        this.monthSelected = new EventEmitter();
        this._dates = [];
        this._eventDestructors = [];
        this._keyDestructors = [];
        this._redraw$ = new Subject();
        this._labels = {};
        this._minDates = {};
        this._maxDates = {};
        this._disabled = false;
        this.onChange = function () { };
        this.onTouch = function () { };
        this.dateFilter = function () {
            return true;
        };
        this._element = _element.nativeElement;
    }
    Object.defineProperty(UiCalendarComponent.prototype, "minMonthDate", {
        get: function () {
            return this._minDates[CalendarView.Month];
        },
        set: function (value) {
            this._minDates[CalendarView.Month] = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiCalendarComponent.prototype, "maxMonthDate", {
        get: function () {
            return this._maxDates[CalendarView.Month];
        },
        set: function (value) {
            this._maxDates[CalendarView.Month] = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiCalendarComponent.prototype, "minYearDate", {
        get: function () {
            return this._minDates[CalendarView.Year];
        },
        set: function (value) {
            this._minDates[CalendarView.Year] = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiCalendarComponent.prototype, "maxYearDate", {
        get: function () {
            return this._maxDates[CalendarView.Year];
        },
        set: function (value) {
            this._maxDates[CalendarView.Year] = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiCalendarComponent.prototype, "minMultiYearDate", {
        get: function () {
            return this._minDates[CalendarView.MultiYear];
        },
        set: function (value) {
            this._minDates[CalendarView.MultiYear] = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiCalendarComponent.prototype, "maxMultiYearDate", {
        get: function () {
            return this._maxDates[CalendarView.MultiYear];
        },
        set: function (value) {
            this._maxDates[CalendarView.MultiYear] = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiCalendarComponent.prototype, "viewMinDate", {
        get: function () {
            if (this._activeView === CalendarView.Month &&
                this.disabled) {
                return DATES.tomorrow;
            }
            return this._minDates[this._activeView];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiCalendarComponent.prototype, "viewMaxDate", {
        get: function () {
            if (this._activeView === CalendarView.Month &&
                this.disabled) {
                return DATES.yesterday;
            }
            return this._maxDates[this._activeView];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiCalendarComponent.prototype, "disabled", {
        get: function () {
            var attributeValue = this._element.getAttribute('disabled') === 'true' ? true : null;
            if (this._disabled !== attributeValue) {
                this.disabled = attributeValue;
            }
            return this._disabled;
        },
        set: function (value) {
            if (this._disabled === value) {
                return;
            }
            this._disabled = !!value ? true : null;
            if (!this.calendar ||
                this.calendar.currentView !== CalendarView.Month) {
                return;
            }
            this.calendar.monthView._init();
            this._cd.detectChanges();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiCalendarComponent.prototype, "calendar", {
        get: function () {
            return this._calendar;
        },
        set: function (calendar) {
            this._calendar = calendar;
            this._destroy();
            this._init();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiCalendarComponent.prototype, "_activeView", {
        get: function () {
            return !!this.calendar ?
                this.calendar.currentView :
                this.startView;
        },
        enumerable: true,
        configurable: true
    });
    UiCalendarComponent.prototype.ngOnDestroy = function () {
        this._dateAdapter.destroy();
        this._destroy();
    };
    UiCalendarComponent.prototype.writeValue = function (value) {
        if (!value ||
            isEqual(this._dates, value)) {
            return;
        }
        var normalizedValue = value.map(function (d) {
            if (moment.isMoment(d)) {
                return d;
            }
            if (moment.isDate(d)) {
                return moment(d);
            }
            throw new Error("Invalid date provided " + (d ? JSON.stringify(d, null, 4) : null));
        });
        this._dates = normalizedValue.slice().sort(function (a, b) { return a.unix() - b.unix(); });
        this._redraw$.next();
        this._cd.markForCheck();
    };
    UiCalendarComponent.prototype.registerOnChange = function (fn) {
        var _this = this;
        this.onChange = function (date) {
            _this._redraw$.next();
            fn(date);
        };
    };
    UiCalendarComponent.prototype.registerOnTouched = function (fn) {
        this.onTouch = fn;
    };
    UiCalendarComponent.prototype.selectDate = function (date) {
        if (this.viewMinDate &&
            this._dateAdapter.compareDate(date, this.viewMinDate) < 0 ||
            this.viewMaxDate &&
                this._dateAdapter.compareDate(date, this.viewMaxDate) > 0) {
            return;
        }
        var idx = this._dates.findIndex(function (d) { return d.date() === date.date() &&
            d.month() === date.month() &&
            d.year() === date.year(); });
        if (idx > -1) {
            this._dates.splice(idx, 1);
        }
        else {
            this._dates.push(date);
        }
        this._dates = this._dates.slice().sort(function (a, b) { return a.unix() - b.unix(); });
        this.calendar.activeDate = date;
        this.selectedChange.emit(date);
        this.onChange(this._dates);
        this.onTouch();
    };
    UiCalendarComponent.prototype.selectMonth = function (date) {
        this.monthSelected.emit(date);
        this._redraw$.next({
            view: CalendarView.Month,
            date: date,
        });
        this.onTouch();
    };
    UiCalendarComponent.prototype.selectYear = function (date) {
        this.yearSelected.emit(date);
        this._redraw$.next({
            view: CalendarView.Year,
            date: date,
        });
        this.onTouch();
    };
    UiCalendarComponent.prototype.goToDate = function (date) {
        this.calendar._goToDateInView(date, 'month');
    };
    UiCalendarComponent.prototype._init = function () {
        var _a;
        var _this = this;
        (_a = this._eventDestructors).push.apply(_a, this._redrawTrigger('.mat-calendar-previous-button', '.mat-calendar-next-button', '.mat-calendar-period-button', '.mat-calendar-period-button'));
        this._redrawSub = this._redraw$
            .pipe(delay(0))
            .subscribe(function (options) {
            if (options === void 0) { options = emptyRedraw; }
            return _this._markCalendar((options.view || _this.calendar.currentView), (options.date || _this.calendar.activeDate));
        });
        this._redraw$.next();
    };
    UiCalendarComponent.prototype._destroy = function () {
        this._invokeEventDestructors(this._eventDestructors);
        this._invokeEventDestructors(this._keyDestructors);
        unsubscribe(this._redrawSub);
    };
    UiCalendarComponent.prototype._markCalendar = function (view, filterDate) {
        switch (view) {
            case CalendarView.Month:
                this._watchViewChange(this.calendar.monthView);
                return this._markMonthView(filterDate);
            case CalendarView.Year:
                this._watchViewChange(this.calendar.yearView);
                return this._markYearView(filterDate);
            case CalendarView.MultiYear:
                this._watchViewChange(this.calendar.multiYearView);
                return this._markMultiYearView();
        }
    };
    UiCalendarComponent.prototype._markMonthView = function (filterDate) {
        var _this = this;
        var view = this._element.querySelector('mat-month-view');
        if (!view) {
            return;
        }
        var activeMonth = this._dateAdapter.getMonth(filterDate);
        var activeYear = this._dateAdapter.getYear(filterDate);
        var selectedDays = this._dates.filter(function (date) { return _this._dateAdapter.getMonth(date) === activeMonth &&
            _this._dateAdapter.getYear(date) === activeYear; }).map(function (date) { return _this._dateAdapter.getDateNames()[date.get('date') - 1]; });
        Array.from(this._element.querySelectorAll('.mat-calendar-body-cell'))
            .forEach(function (element) {
            var day = ((element.querySelector('.mat-calendar-body-cell-content') || {})
                .textContent || '')
                .trim();
            if (!selectedDays.includes(day)) {
                _this._renderer.removeClass(element, 'date-selected');
                _this._renderer.setAttribute(element, 'aria-selected', 'false');
            }
            else {
                _this._renderer.addClass(element, 'date-selected');
                _this._renderer.setAttribute(element, 'aria-selected', 'true');
            }
        });
    };
    UiCalendarComponent.prototype._markYearView = function (filterDate) {
        var _this = this;
        var view = this._element.querySelector('mat-year-view');
        if (!view) {
            return;
        }
        var activeYear = this._dateAdapter.getYear(filterDate);
        var monthCounts = groupBy(this._dates.filter(function (date) { return _this._dateAdapter.getYear(date) === activeYear; }), function (date) { return _this._dateAdapter.getMonth(date); });
        Array.from(this._element.querySelectorAll('.mat-calendar-body-cell-content'))
            .forEach(function (element, idx) {
            _this._appendCountLabel(element, monthCounts[idx], idx);
        });
    };
    UiCalendarComponent.prototype._markMultiYearView = function () {
        var _this = this;
        var view = this._element.querySelector('mat-multi-year-view');
        if (!view) {
            return;
        }
        var countAggregate = groupBy(this._dates, function (date) { return _this._dateAdapter.getYearName(date); });
        Array.from(this._element.querySelectorAll('.mat-calendar-body-cell-content'))
            .forEach(function (element) {
            var key = element
                .innerHTML
                .trim().replace(Array.from(element.children)
                .map(function (child) { return child.outerHTML.trim(); })
                .join(), '');
            _this._appendCountLabel(element, countAggregate[key], key);
        });
    };
    UiCalendarComponent.prototype._appendCountLabel = function (el, list, key) {
        var hasCount = !!list;
        if (this._labels[key]) {
            this._renderer.removeChild(el, this._labels[key]);
            this._renderer.removeClass(el, 'populated');
        }
        this._labels[key] = this._renderer.createElement('span');
        this._renderer.addClass(this._labels[key], 'date-count-label');
        if (!hasCount) {
            this._renderer.addClass(this._labels[key], 'date-count-label-empty');
        }
        this._renderer.appendChild(this._labels[key], this._renderer.createText("" + (hasCount ?
            list.length :
            0)));
        this._renderer.appendChild(el, this._labels[key]);
        this._renderer.addClass(el, 'populated');
    };
    UiCalendarComponent.prototype._redrawTrigger = function () {
        var _this = this;
        var selectors = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            selectors[_i] = arguments[_i];
        }
        return selectors.map(function (selector) {
            return _this._renderer.listen(_this._element.querySelector(selector), 'click', function () {
                _this._redraw$.next();
                _this.onTouch();
            });
        });
    };
    UiCalendarComponent.prototype._watchViewChange = function (view) {
        var _this = this;
        unsubscribe(this._viewChangeSub);
        var rows = Array.from(this._element.querySelectorAll('.mat-calendar-body-cell'));
        this._invokeEventDestructors(this._keyDestructors);
        this._keyDestructors = rows.map(function (row) {
            return _this._renderer.listen(row, 'keydown', function (ev) {
                if (ev.keyCode === ENTER) {
                    // Prevent ENTER key from marking the currently focused day and then immediately submitting the form.
                    ev.stopPropagation();
                    _this._element.dispatchEvent(_this._createKeyboardEvent('keydown', ENTER, 'Enter'));
                }
            });
        });
        this._viewChangeSub = view.activeDateChange
            .pipe(startWith(this.calendar.activeDate), pairwise(), filter(function (_a) {
            var previous = _a[0], current = _a[1];
            return !_this._isSameView(previous, current);
        }))
            .subscribe(function () {
            return _this._redraw$.next();
        });
    };
    UiCalendarComponent.prototype._isSameView = function (previous, current) {
        if (this.calendar.currentView === 'month') {
            return this._dateAdapter.getYear(previous) === this._dateAdapter.getYear(current) &&
                this._dateAdapter.getMonth(previous) === this._dateAdapter.getMonth(current);
        }
        if (this.calendar.currentView === 'year') {
            return this._dateAdapter.getYear(previous) === this._dateAdapter.getYear(current);
        }
        // Otherwise we are in 'multi-year' view.
        return Math.floor(this._dateAdapter.getYear(previous) / YEARS_PER_PAGE) ===
            Math.floor(this._dateAdapter.getYear(current) / YEARS_PER_PAGE);
    };
    UiCalendarComponent.prototype._invokeEventDestructors = function (destructors) {
        destructors.forEach(function (destructor) { return destructor(); });
    };
    UiCalendarComponent.prototype._createKeyboardEvent = function (type, keyCode, key) {
        var ctor = isInternetExplorer() ? IEKeyboardEvent : KeyboardEvent;
        var options = {
            code: "" + keyCode,
            key: key,
            bubbles: true,
        };
        return new ctor(type, options);
    };
    return UiCalendarComponent;
}());
export { UiCalendarComponent };
